import { GET_ALL_COUPONS_SUCCESS } from '../actions/actionTypes';

export default function allCoupons(state = [], action) {
  switch (action.type) {
    case GET_ALL_COUPONS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
